import "./module/userAgentChecker.min.js";
import "./module/plugin.js";
import "./module/page-company.js";

import objectFitImages from "object-fit-images";
objectFitImages();

require("picturefill");

import Swiper from "swiper/bundle";
var swiper01 = new Swiper(".projectSlider", {
    slidesPerView: "auto",
    spaceBetween: 50,
    scrollbar: {
        el: ".swiper-scrollbar",
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

//マウスカーソルパララックス
import Parallax from "parallax-js";
var scene = document.getElementById("scene");
var parallax = new Parallax(scene);

var $ = require("jquery");

var swiper02 = new Swiper(".projectsSlider", {
    simulateTouch: false,
});
// slideToメソッドを実行する関数を定義
$(".projects__containerFlexFigThumItem:first").addClass("active");
$(".projects__containerFlexFigThumItemLink").on("click", function () {
    var elm = $(this).parent().index();
    swiper02.slideTo(elm);
    $(this).parent().toggleClass("active");
    $(".projects__containerFlexFigThumItemLink")
        .not(this)
        .parent()
        .removeClass("active");
});

//companyページ

import ModalVideo from "modal-video";
new ModalVideo(".js-modal-btn", {
    youtube: {
        autoplay: 1,
        controls: 1,
        nocookie: true,
        //mute:0,
        loop: 1,
        showinfo: 0,
    },
});
